import { redirect } from "react-router-dom";
import apiInstance from "./config/api";
import { getAlbumDetails } from "./redux/album/albumAction";
import { fetchGroupProfile } from "./redux/group/groupReducer";
import { getUserDetails } from "./redux/other-users/usersAction";
import store, { queryClient } from "./redux/store";
import { getNaray8Chapter, getNaray8Owner, getNaray8Story, getNaray8Writer } from "./redux/naray8/naray8Action";
import { getPostById } from "./redux/post/postAction";
import { getSingleReelsById } from "./redux/reels/reelsAction";

export const userProfileLoader = async ({ params }) => {
    try {
        const { userId } = params;
        const userProfile = store.getState().users.userData
        if (userId === userProfile.userId) {
            store.dispatch(getUserDetails(userId))
            return null
        }
        await store.dispatch(getUserDetails(userId)).unwrap();
        return null
    }
    catch (error) {
        throw new Error(error.message)
    }

}

export const getPublicRouteUser = async () => {
    try {
        if (!store.getState().user.userData.userId) {
            const request = await apiInstance.get("/api/user/user-details")
            const response = request.data
            if (response.status === "success") {
                return redirect("/");
            } else {
                throw new Error(response.message);
            }
        } else {
            return redirect('/')
        }
    } catch (error) {
        if (error?.status === 401) { console.log("proceed to login"); return null }
        throw new Error(error.message);
    }
}

export const groupProfileLoader = async ({ params }) => {
    try {
        const { groupId } = params;
        const group = store.getState().group.profiles[groupId]
        if (!group) {
            await store.dispatch(fetchGroupProfile(groupId)).unwrap();
        } else {
            store.dispatch(fetchGroupProfile(groupId))
        }
        return null
    }
    catch (error) {
        throw new Error(error.message)
    }

}

export const getPostLoader = async ({ params }) => {
    try {
        const { postId } = params;
        return queryClient.ensureQueryData({
            queryKey: ["post", postId],
            queryFn: () => getPostById(postId),
        });
    }
    catch (error) {
        throw new Error(error.message)
    }
};

export const getReelLoader = async ({ params }) => {
    try {
        const { postId } = params;
        const loadedViewReels = store.getState().reels.viewReels

        if (loadedViewReels?.length === 0 && postId) {
            return queryClient.ensureQueryData({
                queryKey: ["reels", postId],
                queryFn: () => getSingleReelsById(postId),
            });
        }
        return null
    }
    catch (error) {
        throw new Error(error.message)
    }
};;


export const albumDetailLoader = async ({ params }) => {
    try {
        const { albumId } = params;
        const albumDetails = store.getState().album.albums
        if (albumDetails[albumId]) {
            store.dispatch(getAlbumDetails(albumId))
            return null
        }
        await store.dispatch(getAlbumDetails(albumId)).unwrap();
        return null
    }
    catch (error) {
        throw new Error(error.message)
    }

}


export const naray8UploadStoryLoader = async ({ params }) => {
    try {
        const { storyId } = params ?? {}
        if (storyId) {
            return queryClient.ensureQueryData({
                queryKey: ["upload", "naray8", storyId],
                queryFn: () => getNaray8Owner(storyId)
            });
        }
        return null
     }
    catch (error) {
        throw new Error(error.message)
    }
}


export const naray8WriterLoader = async ({ params }) => {
    try {
        let writerId
        if (params?.writerId === "me") {
            if (store.getState().user.userData.userId) {
                writerId = store.getState().user.userData.userId
            } else {
                const request = await apiInstance.get("/api/user/user-details")
                const response = request.data.user
                writerId = response.userId
            }
            writerId = store.getState().user.userData.userId
        } else {
            writerId = params?.writerId
        }

        return queryClient.ensureQueryData({
            queryKey: ["naray8", "writer", writerId],
            queryFn: () => getNaray8Writer(writerId, params?.writerId === "me"),
        });
    }
    catch (error) {
        throw new Error(error.message)
    }
};

export const naray8StoryLoader = async ({ params }) => {
    try {
        const { narrateId } = params;
        return queryClient.ensureQueryData({
            queryKey: ["naray8", narrateId],
            queryFn: () => getNaray8Story(narrateId),
        });
    }
    catch (error) {
        throw new Error(error.message)
    }
};

export const naray8ChapterLoader = async ({ params }) => {
    try {
        const { chapterId } = params;
        return queryClient.ensureQueryData({
            queryKey: ["naray8", "chapter", chapterId],
            queryFn: () => getNaray8Chapter(chapterId),
        });
    }
    catch (error) {
        throw new Error(error.message)
    }
};


// export const walletDetailLoader = async () => {
//     try {
//         return queryClient.ensureQueryData({
//             queryKey: ["wallet", "details"],
//             queryFn: getWalletDetails
//         })
//     } catch (error) {
//         throw new Error(error.message)
//     }
// }